import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import mapProps from 'map-props';
import cns from 'classnames';

import Link from 'components/Link';

import cn from './styles.local.less';
import propsMapping from './propsMapping';

class Breadcrumbs extends PureComponent {
  static propTypes = {
    activeText: PropTypes.string,
    cmsHtml: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
  };

  static defaultProps = {
    items: [],
  };

  render() {
    const { activeText, cmsHtml, className, items } = this.props;

    return cmsHtml ? (
      <div
        className={cns(cn.root, className)}
        dangerouslySetInnerHTML={{ __html: cmsHtml }}
      />
    ) : (
      <div className={cns(cn.root, className)}>
        <ol className="breadcrumb">
          <li>
            <a href="/">{__('carDetails.siteName')}</a>
          </li>
          {items.map(({ text, href }, index) => (
            <li key={`${href}_${index}`}>
              <Link to={href}>{text}</Link>
            </li>
          ))}
          <li className="active">{activeText}</li>
        </ol>
      </div>
    );
  }
}

export default mapProps(propsMapping)(Breadcrumbs);
